import React, { useContext, useState } from 'react'
import CustomTextField from './CustomTextField'
import AccessControl, { checkPermissions } from '../views/AccessControl'
import { useUserState } from '../context/UserContext';
import { Box, IconButton, Typography } from '@mui/material';
import { Colours } from '../assets/global/Theme-variable';
import { SortableList } from './SortableList';
import { Barcode } from './Barcode';
import { nanoid } from 'nanoid';
import DoneIcon from '@mui/icons-material/Done';
import { DataGridContext } from '../context/DataGridContext';

export default function Barcodes({item, setItem, barcodes, setBarcodes}) {
    const userPermission = useUserState();
   const [newBarcode, setNewBarcode ] = useState('')
   const [errorMsg, setErrorMsg ] = useState('')

   const [isNew, setIsNew ] = useState(false)
const {data } = useContext(DataGridContext)
 const addNew = () => {
setIsNew(true)
}

const submit = () => {   
    const isDuplicate =  data?.items?.some((x) => Array.isArray(x?.plu_details?.barcode) && x?.plu_details?.barcode?.includes(newBarcode)) || data?.items?.some((x) => x?.plu_details?.barcode === newBarcode) || barcodes.some((x)=> x.barcode === newBarcode)
    console.log(data?.items?.filter((x) => {
     return x?.plu_details?.barcode?.includes(newBarcode)
    }))
      if(isDuplicate) {
      setErrorMsg('This barcode is already in use, please use a different number')
    } else {
      setBarcodes((items) => [...items, { id: nanoid(), barcode: newBarcode }]);
      setItem({
        ...item,
        plu_details: { ...item.plu_details, barcode: barcodes },
      });
     setIsNew(false)
      setNewBarcode('')
    }
    }

 const handleRemove = (id) => {
    const newBarcodes = barcodes.filter((code) => code.id !== id);
    setBarcodes(newBarcodes);
    setItem({
      ...item,
      plu_details: { ...item.plu_details, barcode: newBarcodes },
    });
  };

  const handleNewBarcode= (event) => {
    setErrorMsg('')
      setNewBarcode(event.target.value)
  }

 return (
    <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      width: "100%",
      height: "100%",
      overflow: "auto",
    }}
  >
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        height: "10%",
        mb: 2,
      }}
    >
      <Box
        sx={{
          width: 70,
          // height: 30,
          display: "flex",
          justifyContent: "center",
        }}
      >
        {/* <Typography sx={{ fontSize: 12 }}>Number</Typography> */}
      </Box>
      <Box
        sx={{
          // width: 50,
          // height: 30,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <AccessControl
          userPermissions={userPermission}
          unallowedPermissions={{
            page: "items",
            // allow: false,
            action: "edit",
            strict: false,
          }}
          // renderNoAccess={() => <NoAccess permissionsNeeded="read:stats" />}
          renderNoAccess={() => <></>}
        >
          <IconButton
            aria-label="add modifier"
            onClick={addNew}
            sx={{ borderRadius: 1 }}
          >
            {/* <AddIcon color={Colours.gsblue} /> */}
            <Typography sx={{ fontSize: 14 }} color={Colours.gsblue}>
              + ADD NEW
            </Typography>
          </IconButton>
        </AccessControl>
      </Box>
  
    </Box>
    {isNew &&
    <>
      <Box sx={{width:'100%',display:'flex', flexDirection:'row', justifyContent:'space-between', alignItems:'flex-end', }}>
         <CustomTextField
         value={newBarcode}
         type="barcode"
         multiline={false}
         disabled={
           !checkPermissions(userPermission, {
             page: "items",
             // allow: false,
             strict: false,

             action: "edit",
           })
         }
        //  width={"60%"}
         label={
           <Typography
             sx={{
               fontSize: 18,
               mb: 0,
               color: Colours.gsblue,
               justifySelf: "flex-start",
             }}
           >
             Barcode
           </Typography>
         }
         onChange={handleNewBarcode
         }
       />
       <IconButton
       aria-label="add modifier"
       onClick={submit}
       disabled={newBarcode.length < 1}
       sx={{ borderRadius: 1 }}
     ><DoneIcon/></IconButton>
  </Box>       
     <Typography sx={{fontSize: 10, color:Colours.red, mb:2}}>{errorMsg}</Typography>
  </>
     }
   {barcodes?.length > 0 ? (
      <SortableList
        items={barcodes}
        onChange={setBarcodes}
        renderItem={(barcode) => (
          <SortableList.Item id={barcode?.id}>
            <Barcode
              item={item}
              removeItem={handleRemove}
              barcodes={barcodes}
              setItem={setItem}
              setBarcodes={setBarcodes}
              barcode={barcode}
            />
          </SortableList.Item>
        )}
      />
    
    ) : (
      <Typography>No Barcodes</Typography>
    )}
  </Box>
   

  )
}
